module.exports = __webpack_public_path__ + "static/img/cw.9438ff9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cw.png
// module id = dEHR
// module chunks = 0